import type { ApiClient } from './client.js';

/**
 * Follow a cursor-paginated `{ data, meta: { has_more, cursor? } }` list endpoint (#669),
 * accumulating every page. `makePath(cursor)` builds the request path for a given cursor
 * (undefined on the first page). Shared by `rekor tokens list`/`prune` and `rekor secrets list`,
 * which must see the whole fleet even though the server returns one bounded page per request.
 */
export async function collectPages<T>(
  client: ApiClient,
  makePath: (cursor: string | undefined) => string,
): Promise<T[]> {
  const all: T[] = [];
  let cursor: string | undefined;
  do {
    const { data, meta } = await client.requestEnvelope<T[]>('GET', makePath(cursor));
    all.push(...(data ?? []));
    cursor = meta?.has_more ? meta.cursor : undefined;
  } while (cursor);
  return all;
}
